import * as addonSelector from 'state/addonForm/addonForm.selector';
import {
  getBatchFormInfos,
  getDynamicWrapper,
  getFormEnrichedData,
  getFormProductSubType,
  getProductAssetTypesByWorkspace,
  getStaticFormInfos,
  getStaticWrapper,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType, WorkspaceType } from 'state/workspaces/model';
export type PayoffType = 'OTC' | 'Note';

export function formProductContainsAssetType(
  state: AppState,
  tabId: string,
  workspace: QuoteWorkspaceType,
  assetType: string,
) {
  const productAssets = getAssetTypes(state, tabId, workspace);
  return productAssets?.includes(assetType) ?? false;
}
export function formProductContainsAssetTypes(
  state: AppState,
  tabId: string,
  workspace: QuoteWorkspaceType,
  ...assetTypes: string[]
) {
  const productAssets = getAssetTypes(state, tabId, workspace);
  return assetTypes.some(assetType => productAssets?.includes(assetType));
}

export function getAssetTypes(state: AppState, tabId: string, workspace: QuoteWorkspaceType) {
  switch (workspace) {
    case 'dynamic':
      return getAssetTypesForDynamicScreen(state, tabId);
    case 'static':
      return getAssetTypesForStaticScreens(state, tabId, workspace);
    case 'newBatch':
      return getAssetTypesForStaticScreens(state, tabId, workspace);
    case 'postTrade':
      return getAssetTypesForPostTrade(state, tabId);
  }
}

const getAssetTypesForPostTrade = (state: AppState, tabId: string) => {
  return addonSelector.getAssetTypes(state, tabId) ?? [];
};

const getAssetTypesForDynamicScreen = (state: AppState, tabId: string) => {
  const data = getFormEnrichedData(state, tabId) as { AssetTypes?: string[] } | undefined;
  return data?.AssetTypes ?? [];
};

function getAssetTypesForStaticScreens(state: AppState, tabId: string, workspace: QuoteWorkspaceType) {
  const productSubType = getFormProductAssets(state, tabId, workspace);
  if (productSubType === undefined) {
    return [];
  }
  return getProductAssetTypesByWorkspace(state, workspace, productSubType);
}

function getFormProductAssets(state: AppState, tabId: string, workspace: QuoteWorkspaceType) {
  switch (workspace) {
    case 'static':
      return getStaticFormInfos(state, tabId)?.productDescription;
    case 'newBatch':
      return getBatchFormInfos(state, tabId)?.productSubType;
  }
}
const getWrapper = (state: AppState, tabId: string, workspace: WorkspaceType) => {
  switch (workspace) {
    case 'dynamic':
      return getDynamicWrapper(state, tabId);
    case 'static':
      return getStaticWrapper(state, tabId);
    case 'postTrade':
      return addonSelector.getWrapper(state, tabId);
  }
};
export function getPayOffType(state: AppState, tabId: string, workspace: WorkspaceType): PayoffType {
  const wrapper = getWrapper(state, tabId, workspace);
  if (wrapper === 'Note') {
    return 'Note';
  }
  return 'OTC';
}

export function formProductSubtypeIs(state: AppState, tabId: string, subType: string) {
  const productSubtype = getFormProductSubType(state, tabId);
  return productSubtype === subType;
}
